<template>
  <v-container fluid>
    <alert-error :error="error"></alert-error>
    <v-toolbar>
      <v-toolbar-title>{{ $t('EREPORTER.PAYROLLS.ITEMS') }}</v-toolbar-title>
    </v-toolbar>

    <v-sheet class="mt-5 pa-5" tile>
      <payrolls-list-filter
        @setRequest="setRequest"
        @setExportOptions="setExportOptions"
      />
      <payrolls-list
        v-model="selected"
        :payrolls="payrolls"
        :options="options"
        :export-options="exportOptions"
        :meta="meta"
        @show="show"
        @refresh="getDataPayrolls"
        @changeShowSelect="changeShowSelect"
      ></payrolls-list>
    </v-sheet>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import PayrollsList from '../../components/Payrolls/PayrollsList';
import PayrollsListFilter from '../../components/forms/Payrolls/PayrollsListFilter';
import { debounce, cloneDeep } from 'lodash';
const DEBOUNCE_DELAY = 300;

export default {
  name: 'PayrollsPage',

  components: {
    PayrollsList,
    PayrollsListFilter,
    AlertError: () => import('@/modules/_global/_components/AlertError')
  },

  data() {
    return {
      error: null,
      selected: [],
      meta: {},
      showSelectedOnly: false,
      options: {},
      exportOptions: {}
    };
  },

  computed: {
    ...mapState('ereporter', ['payrolls']),
    selectedIds() {
      const ids = this.selected.map(i => i.id);
      return ids.length ? ids : [''];
    }
  },
  watch: {
    selected: {
      handler(v) {
        this.changeSelected(v);
      },
      deep: true
    }
  },

  methods: {
    ...mapActions('ereporter', ['getPayrolls']),
    getDataPayrolls: debounce(function debouncedGetPayrolls(params) {
      this.getPayrolls(params)
        .then(({ data }) => {
          this.meta = data.meta;
        })
        .catch(error => {
          this.error = error;
        });
    }, DEBOUNCE_DELAY),
    setRequest(v = this.options) {
      this.selected = [];
      this.options = {
        ...v,
        ids: this.showSelectedOnly ? this.selectedIds : []
      };
    },
    setExportOptions(v) {
      this.exportOptions = v;
    },
    show(item) {
      this.$router.push({
        name: 'ereporter.payroll.show',
        params: { id: item.id }
      });
    },
    changeShowSelect(v) {
      this.showSelectedOnly = v;
      this.setRequest();
    },
    changeSelected(v) {
      if (this.showSelectedOnly) {
        this.setRequest();
      }
    }
  }
};
</script>
